/* eslint-disable @typescript-eslint/explicit-member-accessibility, @typescript-eslint/explicit-function-return-type, @typescript-eslint/typedef */
import { Component, ComponentType } from 'react';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import DevicesMenu from '../../DevicesMenu';
import React from 'react';

import withStyles from '@mui/styles/withStyles';
import createStyles from '@mui/styles/createStyles';
import { WithStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { withRouter, WithRouterProps } from '../../common/withRouter';
import ListItemIcon from '@mui/material/ListItemIcon/ListItemIcon';
import ArrowRight from '@mui/icons-material/ArrowRight';
import * as roles from '../../common/role_utils';
import { TFunction, withTranslation } from 'react-i18next';
import GoogleAnalyticsService from '../../common/GoogleAnalyticsService';
import { GaEventCategory } from '../../common/GaEventCategory';
import { GaEventAction } from '../../common/GaEventAction';
import LicenseValidator from '../../common/LicenseValidator';
import Fade from '@mui/material/Fade';
import { submitSessionLogout } from '@thingslog/utils';
import { clearSessionUser } from '../../common/sessionUser';
import {
  clearHeaderMenuMode,
  isOldHeaderMenuMode,
  readHeaderMenuMode,
  writeHeaderMenuMode,
} from './utils/headerMenuMode';
import { isAgriIconVisible, isFeatureFlagOn } from './utils/headerSelectors';
import { buildSameOriginUrl } from './utils/headerNavigation';
import { getVisibleOldMainMenuItems, HeaderOldMainMenuItem } from './old-menu/oldMainMenuConfig';
import { ProfileMenu } from './profile/ProfileMenu';
import { AxiosError } from 'axios';
import type { i18n as I18nInstance } from 'i18next';
import UserClient from '../../UserClient';
import ErrorUtil from '../../common/ErrorUtil';
import { TopAppBar } from './shell/TopAppBar';
import { HeaderShell } from './shell/HeaderShell';
import { OldMenuDrawer } from './old-menu/OldMenuDrawer';
import { NewSideMenu } from './new-menu/NewSideMenu';
import { AuthState } from '../../reducers/auth_reducer';
import { CompanySelectionState } from '../../reducers/company_reducer';
import { FeatureFlagState } from '../../reducers/feature_flag_reducer';

const LegacyList = List as ComponentType<{ open?: boolean; children?: React.ReactNode }>;
const LegacyDevicesMenu = DevicesMenu as ComponentType<{
  deviceNumber?: string | string[];
  open?: boolean;
  onClose?: () => void;
}>;

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    toolbar: {
      paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 8px',
      ...theme.mixins.toolbar,
    },
    appBar: {
      zIndex: 20,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: 240,
      width: `calc(100% - 240px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginLeft: 12,
      marginRight: 36,
    },
    menuButtonHidden: {
      display: 'none',
    },
    title: {
      flexGrow: 1,
      // Allow the title to shrink/truncate so the action buttons never get
      // pushed onto a second line.
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    headerActions: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'nowrap',
      // Never let the buttons shrink or wrap below the title.
      flexShrink: 0,
    },
    drawerPaper: {
      position: 'relative',
      whiteSpace: 'nowrap',
      zIndex: 20,
      width: 240,
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerPaperClose: {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(0),
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(0),
      },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      overflow: 'auto',
    },
    contentFullHeight: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      overflow: 'hidden',
      padding: 0,
    },
    chartContainer: {
      marginLeft: -22,
    },
    tableContainer: {
      height: '90%',
    },
    tableContainerFullHeight: {
      display: 'flex',
      flex: '1 1 auto',
      minHeight: 0,
      height: 'auto',
    },
    h5: {
      marginBottom: theme.spacing(2),
    },
    headerLogoContainer: {
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
      transition: 'max-width 0.3s ease',
      maxWidth: 'clamp(0px, (100vw - 600px), 250px)',
      opacity: 1,
      [theme.breakpoints.down(632)]: {
        display: 'none',
      },
    },
    headerLogo: {
      height: 32,
      marginRight: theme.spacing(2),
      flexShrink: 0,
    },
    documentationHeaderButton: {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    documentationProfileItem: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
      },
    },
    menuContent: {
      flex: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
    },
  });

export type HeaderProps = {
  children?: React.ReactNode;
  fullHeightContent?: boolean;
  isHeaderVisible?: boolean;
};

interface HeaderInternalProps extends HeaderProps, WithStyles<typeof styles>, WithRouterProps {
  t: TFunction<'translation', undefined>;
  i18n: I18nInstance;
  drawerOpened?: boolean | null;
  // Redux state slices (canonical types from reducers/*)
  auth: AuthState;
  company: CompanySelectionState;
  featureFlags: FeatureFlagState;
  // `dev` reducer is still untyped JS, so these are declared explicitly
  devices: string[];
  selectMode: 'radio' | 'checkbox';
  menuOpen: boolean;
  devMenu: boolean;
  // Action creators (actions module is untyped JS)
  devOpenCloseMenu: (open: boolean) => void;
  devOpenCloseDevMenu: (open: boolean, devMenu: boolean) => void;
  languageChanged: (language: string) => void;
}

interface HeaderState {
  open: boolean;
  generalOpen: boolean;
  deviceOpen: boolean;
  profileMenuOpen: boolean;
  anchorEl: HTMLElement | null;
  useOldMenu: boolean;
}

class Header extends Component<HeaderInternalProps, HeaderState> {
  constructor(props: HeaderInternalProps) {
    super(props);
    this.state = {
      open: this.props.drawerOpened ?? false,
      generalOpen: false,
      deviceOpen: false,
      profileMenuOpen: false,
      anchorEl: null,
      useOldMenu: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleDevicesMenuButtonClicked = this.handleDevicesMenuButtonClicked.bind(this);
    this.handleDeviceMenuClose = this.handleDeviceMenuClose.bind(this);
    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
    this.handleDrawerClose = this.handleDrawerClose.bind(this);
    this.handleProfileMenuToggle = this.handleProfileMenuToggle.bind(this);
    this.handleProfileMenuIconClick = this.handleProfileMenuIconClick.bind(this);
  }

  componentDidMount() {
    this.setState({ useOldMenu: isOldHeaderMenuMode(readHeaderMenuMode()) });
  }
  handleToggle() {
    this.props.devOpenCloseMenu(!this.props.menuOpen);
    if (this.props.menuOpen) {
      this.switchToOldMenu(false);
    }
  }

  handleProfileMenuToggle() {
    this.setState({ profileMenuOpen: !this.state.profileMenuOpen });
  }

  handleProfileMenuIconClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    this.setState({
      profileMenuOpen: !this.state.profileMenuOpen,
      anchorEl: event.currentTarget,
    });
  };

  handleLanguageSelect = (language: string) => {
    // Update the UI language immediately via redux (App syncs i18n + date locale).
    this.props.languageChanged(language);
    GoogleAnalyticsService.triggerEvent(
      GaEventCategory.PROFILE_PAGE,
      GaEventAction.CHANGE_LANGUAGE_SAVE
    );
    // Restricted users cannot persist their preference, so skip the request.
    if (this.props.auth.isRestricted) {
      return;
    }
    UserClient.putUser(
      this.props.auth.username,
      { language },
      () => {
        const decodedToken = localStorage.getItem('decoded_token');
        if (decodedToken) {
          const decoded = JSON.parse(decodedToken);
          decoded.language = language;
          localStorage.setItem('decoded_token', JSON.stringify(decoded));
        }
        this.props.i18n.changeLanguage(language);
      },
      (error: AxiosError) => ErrorUtil.handleErrorWithAlert(error)
    );
  };

  handleClose() {
    this.props.devOpenCloseMenu(false);
  }

  handleOpen() {
    this.props.devOpenCloseMenu(false);
    this.props.devOpenCloseDevMenu(true, true);
  }

  switchToOldMenu = (value) => {
    this.setState({ useOldMenu: value });
    writeHeaderMenuMode(value ? 'old' : 'new');
  };

  isFeatureFlagOn = (flagName) => {
    return isFeatureFlagOn(this.props.featureFlags, flagName);
  };

  renderOldMainMenuItem(item: HeaderOldMainMenuItem) {
    const handleClick = () => {
      if (item.kind === 'device-menu') {
        this.handleOpen();
      } else if (item.path) {
        this.props.devOpenCloseMenu(false);
        this.props.history.push(item.path);
      }

      if (item.gaAction) {
        GoogleAnalyticsService.triggerEvent(GaEventCategory.MENU_NAVIGATION, item.gaAction);
      }
    };

    return (
      <ListItem
        button
        disabled={item.disabled}
        key={`${item.labelKey}-${item.path ?? item.kind}`}
        onClick={handleClick}
      >
        <ListItemText primary={this.props.t(item.labelKey)} />
        {item.kind === 'device-menu' && (
          <ListItemIcon>
            <ArrowRight />
          </ListItemIcon>
        )}
      </ListItem>
    );
  }
  renderLinks() {
    // let hasUserRole = roles.hasRole(this.props.auth, roles.ROLE_USER);

    let hasAdminRole = roles.hasRole(this.props.auth, roles.ROLE_ADMIN);
    let hasSuperAdminRole = roles.hasRole(this.props.auth, roles.ROLE_SUPER_ADMIN);
    let hasBillingRole = roles.hasRole(this.props.auth, roles.ROLE_BILLING);

    const { classes } = this.props;
    let menu: React.ReactNode = null;
    if (!this.props.devMenu) {
      const oldMainMenuItems = getVisibleOldMainMenuItems({
        featureFlags: this.props.featureFlags?.featureFlagsArray ?? [],
        hasAdminRole,
        hasBillingRole,
        hasDevices: this.props.devices.length > 0,
        hasLicensesAccess: this.props.auth.hasLicensesAccess ?? false,
        hasSuperAdminRole,
      });

      menu = (
        <LegacyList open={this.props.menuOpen}>
          {oldMainMenuItems.map((item: HeaderOldMainMenuItem) => this.renderOldMainMenuItem(item))}
        </LegacyList>
      );
    } else {
      if (this.props.selectMode === 'radio') {
        menu = (
          <LegacyDevicesMenu
            deviceNumber={this.props.devices}
            open={this.props.menuOpen}
            onClose={this.handleDeviceMenuClose}
          />
        );
      } else if (this.props.selectMode === 'checkbox') {
        menu = (
          <LegacyDevicesMenu
            deviceNumber={this.props.devices[0]}
            open={this.props.menuOpen}
            onClose={this.handleDeviceMenuClose}
          />
        );
      }
    }
    return (
      <OldMenuDrawer
        classes={classes}
        isAuthenticated={this.props.auth.authenticated ?? false}
        menuOpen={this.props.menuOpen}
        onDrawerClose={this.handleDrawerClose}
        onSwitchToNewMenu={() => {
          this.switchToOldMenu(false);
          clearHeaderMenuMode();
        }}
        t={this.props.t}
      >
        {menu}
      </OldMenuDrawer>
    );
  }

  handleDevicesMenuButtonClicked() {
    this.props.devOpenCloseMenu(true);
  }

  handleDeviceMenuClose() {
    this.props.devOpenCloseMenu(false);
    this.switchToOldMenu(false);
  }

  handleDrawerOpen = () => {
    this.props.devOpenCloseMenu(true);
  };

  handleDrawerClose = () => {
    this.props.devOpenCloseMenu(false);
  };

  isAgriIconVisible = () => {
    return isAgriIconVisible(this.props.auth, localStorage.getItem('selectedCompany'));
  };

  redirectToAgri = () => {
    window.location.href = buildSameOriginUrl(window.location, '/portal');
  };

  redirectToEnergy = () => {
    window.location.href = buildSameOriginUrl(window.location, '/energy');
  };

  render() {
    const { classes } = this.props;
    const isHeaderVisible = this.props.isHeaderVisible !== false;
    const appBar = isHeaderVisible ? (
      <TopAppBar
        auth={this.props.auth}
        classes={classes}
        company={this.props.company}
        isAgriIconVisible={this.isAgriIconVisible()}
        menuOpen={this.props.menuOpen}
        onAgriClick={this.redirectToAgri}
        onDocsClick={(e) => {
          e.preventDefault();
          this.props.history.push('/app/docs');
        }}
        onDrawerOpen={this.handleDrawerOpen}
        onEnergyClick={this.redirectToEnergy}
        onProfileMenuIconClick={this.handleProfileMenuIconClick}
      />
    ) : null;
    const profileMenu = (
      <ProfileMenu
        anchorEl={this.state.anchorEl}
        auth={this.props.auth}
        classes={classes}
        currentLanguage={this.props.auth.language}
        featureFlags={this.props.featureFlags}
        isOpen={isHeaderVisible && this.state.profileMenuOpen}
        onClose={this.handleProfileMenuToggle}
        onDocsClick={() => {
          this.props.devOpenCloseMenu(false);
          this.props.history.push('/app/docs');
        }}
        onLanguageSelect={this.handleLanguageSelect}
        onProfileClick={() => {
          this.props.devOpenCloseMenu(false);
          this.props.history.push('/app/Profile');
        }}
        onSettingsClick={() => {
          this.props.history.push('/app/Settings');
        }}
        onSignOutClick={() => {
          this.props.devOpenCloseMenu(false);
          clearHeaderMenuMode();
          clearSessionUser();
          localStorage.removeItem('selectedCompany');
          submitSessionLogout();
        }}
        t={this.props.t}
      />
    );
    const menu = !this.state.useOldMenu ? (
      <NewSideMenu
        companyName={this.props.auth.companyName ?? ''}
        username={this.props.auth.username ?? ''}
        selectedDevice={this.props.devices[0] ?? null}
        menuOpen={this.props.menuOpen}
        switchToOldMenu={this.switchToOldMenu}
      />
    ) : (
      this.renderLinks()
    );

    return (
      <HeaderShell
        appBar={appBar}
        classes={classes}
        fullHeightContent={this.props.fullHeightContent}
        isHeaderVisible={isHeaderVisible}
        menu={menu}
        profileMenu={profileMenu}
      >
        {this.props.children}
      </HeaderShell>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    devices: state.dev.devices,
    selectMode: state.dev.selectMode,
    menuOpen: state.dev.menuOpen,
    devMenu: state.dev.devMenu,
    company: state.company,
    featureFlags: state.featureFlags,
  };
}

const RoutedHeader = withTranslation()(
  withRouter(Header) as ComponentType<Omit<HeaderInternalProps, keyof WithRouterProps>>
);
const StyledHeader = withStyles(styles)(RoutedHeader);

const ConnectedHeader = connect(
  mapStateToProps,
  actions
)(StyledHeader as ComponentType<HeaderProps>) as React.ComponentType<HeaderProps>;

export default ConnectedHeader;
